import React from 'react'
import PropTypes from 'prop-types'

import { useEditorUnsavedModal } from './EditorUnsavedModal.logic.js'
import { EditorUnsavedModalView } from './EditorUnsavedModal.view.jsx'

export function EditorUnsavedModal({ changes }) {
  const { showModal, handleConfirm, handleCancel } = useEditorUnsavedModal({
    changes,
  })

  return (
    <EditorUnsavedModalView
      showModal={showModal}
      handleConfirm={handleConfirm}
      handleCancel={handleCancel}
    />
  )
}

EditorUnsavedModal.propTypes = {
  changes: PropTypes.bool,
}
